import { ActionTree, MutationTree } from 'vuex';
import LightspeedApiService from '@/api/http/LightspeedApiService';
import SimphonyApiService from '@/api/http/SimphonyApiService';
import PulsePosApiService from '@/api/http/PulsePosApiService';
import { RootState } from '@/interfaces/stores/RootState';
import { PosSync } from '@/interfaces/models/PosSync';
import Filter from '@/interfaces/api/Filter';
import { Pagination } from '@/interfaces/api/Pagination';
import { Page } from '@/interfaces/api/Page';
import { PosSyncType } from '@/enums/PosSyncType';
import { AxiosResponse } from 'axios';

interface PosSyncsState {
  items: PosSync[];
  filter: Filter;
  pagination: {
    total: number;
  };
}

const posSyncApis: Record<PosSyncType, LightspeedApiService | SimphonyApiService | PulsePosApiService> = {
  [PosSyncType.LIGHTSPEED]: new LightspeedApiService(),
  [PosSyncType.SIMPHONY]: new SimphonyApiService(),
  [PosSyncType.PULSE]: new PulsePosApiService(),
};

const state: PosSyncsState = {
  items: [],
  filter: {},
  pagination: {
    total: 10,
  },
};

const actions: ActionTree<PosSyncsState, RootState> = {
  fetch({ commit, state }, data: { page: Page; type: PosSyncType }) {
    return posSyncApis[data.type]
      .getPosSyncs(data.page, state.filter)
      .then((res: AxiosResponse<PosSync[] | Pagination<PosSync>>) => {
        commit('setItems', res.data);
      });
  },
  setFilter({ commit }, filter: Filter) {
    commit('setFilter', filter);
  },
};

const mutations: MutationTree<PosSyncsState> = {
  setItems(state: PosSyncsState, data: Pagination<PosSync>) {
    state.items = (data.data as PosSync[]) || data;
    state.pagination.total = data?.total || 0;
  },
  setFilter(state: PosSyncsState, data: Filter) {
    state.filter = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
